import { c as _c } from "react/compiler-runtime";
import { Button, Table as ComponentsTable, TooltipTextOverflow } from '@systemeio/components';
import { PlusIcon, Ticket01Icon, Trash02Icon } from '@systemeio/icons';
import { CurrencyEnum } from '@systemeio/types';
import { COUPONS_API, createCoupon } from 'modules/coupons/api/coupon-api';
import { CouponCreateInterface, CouponErrorsInterface, CouponInterface } from 'modules/coupons/types/coupon-interface';
import AttachCouponModal from 'modules/funnels/funnel/components/step-configuration-tab/coupon-selector/components/attach-coupon-modal';
import { couponDefaultErrors } from 'modules/funnels/funnel/components/step-configuration-tab/coupon-selector/constants/default-error';
import { useAvailableCoupons } from 'modules/funnels/funnel/components/step-configuration-tab/coupon-selector/hooks/use-available-coupons';
import { CouponDefaultErrorsInterface } from 'modules/funnels/funnel/components/step-configuration-tab/coupon-selector/types/default-errors-interface';
import { OfferConfigurationCard } from 'modules/funnels/funnel/components/step-configuration-tab/offer-configuration-card';
import { OfferFormEditType } from 'modules/funnels/funnel/components/step-configuration-tab/offer-form-configuration-tab/types/offer-form-interface';
import React, { useState } from 'react';
import { toast } from 'shared/components';
import Confirmation from 'shared/components/confirmation-modal';
import { IconTile } from 'shared/components/icon-tile';
import { RelativeTime } from 'shared/components/relative-time';
import { MobileCardHeader } from 'shared/components/table/components/mobile-card-header';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useModal } from 'shared/hooks/use-modal';
import { useUpdateData } from 'shared/hooks/use-update-data';
import { fetchWithFieldAndCommonErrors } from 'shared/utils/fetch-with-errors';
const defaultCreateFieldErrors: CouponErrorsInterface = {
  innerName: '',
  code: '',
  discountType: '',
  discountAmount: '',
  currency: '',
  expirationDate: '',
  limitOfUse: '',
  common: ''
};
interface CouponSelectorProps {
  currency: CurrencyEnum;
  data: CouponInterface[];
  onSave: (data: OfferFormEditType['coupons']) => Promise<void>;
}
function CouponSelector(t0) {
  const $ = _c(98);
  const {
    currency,
    data,
    onSave
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [createFieldErrors, setCreateFieldErrors] = useState(defaultCreateFieldErrors);
  const [couponErrors, setCouponErrors] = useState(couponDefaultErrors);
  const {
    opened,
    close,
    open
  } = useModal();
  const [couponToDelete, setCouponToDelete] = useState(null);
  const [shouldFetchCoupons, setShouldFetchCoupons] = useState(false);
  let t1;
  if ($[0] !== currency || $[1] !== data || $[2] !== shouldFetchCoupons) {
    t1 = {
      currency,
      shouldFetch: shouldFetchCoupons,
      initialData: data
    };
    $[0] = currency;
    $[1] = data;
    $[2] = shouldFetchCoupons;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    availableCoupons
  } = useAvailableCoupons(t1);
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      api: COUPONS_API,
      constantApi: [`${COUPONS_API}/list`]
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const updateData = useUpdateData(t2);
  let t3;
  if ($[5] !== t) {
    t3 = coupon => coupon.expirationDate === null ? t("dashboard.coupon.expiration_date_never") : <RelativeTime time={coupon.expirationDate} />;
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const renderExpiration = t3;
  let t4;
  if ($[7] !== t) {
    t4 = coupon_0 => coupon_0.limitOfUse === null ? t("global.unlimited") : coupon_0.limitOfUse;
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const renderLimitOfUse = t4;
  const renderNumberOfUse = _temp;
  let t5;
  if ($[9] !== t) {
    t5 = coupon_2 => <Button aria-label={t("global.delete")} onClick={() => setCouponToDelete(coupon_2)} size="icon-sm" variant="gray"><Trash02Icon /></Button>;
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const renderRemoveButton = t5;
  let t6;
  if ($[11] !== t) {
    t6 = t("global.name");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = {
      key: "innerName",
      header: t6,
      widthPercent: 25,
      onRender: _temp2
    };
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t("dashboard.coupon.coupon_code");
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t8) {
    t9 = {
      key: "code",
      header: t8,
      widthPercent: 20,
      onRender: _temp3
    };
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t) {
    t10 = t("dashboard.coupon.expiration_date");
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== renderExpiration || $[22] !== t10) {
    t11 = {
      key: "expirationDate",
      header: t10,
      widthPercent: 20,
      onRender: renderExpiration
    };
    $[21] = renderExpiration;
    $[22] = t10;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t) {
    t12 = t("dashboard.coupon.limit_of_use");
    $[24] = t;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== renderLimitOfUse || $[27] !== t12) {
    t13 = {
      key: "limitOfUse",
      header: t12,
      widthPercent: 15,
      onRender: renderLimitOfUse
    };
    $[26] = renderLimitOfUse;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t) {
    t14 = t("dashboard.coupon.coupons_used_available");
    $[29] = t;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t14) {
    t15 = {
      key: "numberOfUse",
      header: t14,
      widthPercent: 15,
      onRender: renderNumberOfUse
    };
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== renderRemoveButton) {
    t16 = {
      key: "remove",
      header: "",
      className: "!w-14",
      widthPercent: 5,
      onRender: renderRemoveButton
    };
    $[33] = renderRemoveButton;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t11 || $[36] !== t13 || $[37] !== t15 || $[38] !== t16 || $[39] !== t7 || $[40] !== t9) {
    t17 = [t7, t9, t11, t13, t15, t16];
    $[35] = t11;
    $[36] = t13;
    $[37] = t15;
    $[38] = t16;
    $[39] = t7;
    $[40] = t9;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  const columns = t17;
  let t18;
  if ($[42] !== open) {
    t18 = () => {
      setCouponErrors(couponDefaultErrors);
      setCreateFieldErrors(defaultCreateFieldErrors);
      setShouldFetchCoupons(true);
      open();
    };
    $[42] = open;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  const handleOpenModal = t18;
  let t19;
  if ($[44] !== updateData) {
    t19 = async createCouponData => {
      let createdCouponId;
      await fetchWithFieldAndCommonErrors(async () => {
        const response = await createCoupon(createCouponData);
        await updateData(true, {});
        createdCouponId = response.data.id;
      }, setCreateFieldErrors);
      return createdCouponId;
    };
    $[44] = updateData;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  const handleCreateCoupon = t19;
  let t20;
  if ($[46] !== close || $[47] !== data || $[48] !== onSave) {
    t20 = async couponId => {
      await fetchWithFieldAndCommonErrors(async () => {
        await onSave([...(data?.map(_temp4) ?? []), couponId]);
        close();
      }, setCouponErrors);
    };
    $[46] = close;
    $[47] = data;
    $[48] = onSave;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  const handleAttachCoupon = t20;
  let t21;
  if ($[50] !== couponToDelete || $[51] !== data || $[52] !== onSave || $[53] !== t) {
    t21 = async () => {
      if (!couponToDelete) {
        return;
      }
      const updatedCoupons = data?.filter(coupon_6 => coupon_6.id !== couponToDelete.id) || [];
      try {
        await onSave(updatedCoupons.map(_temp5));
      } catch {
        toast.error(t("global.error"));
      }
    };
    $[50] = couponToDelete;
    $[51] = data;
    $[52] = onSave;
    $[53] = t;
    $[54] = t21;
  } else {
    t21 = $[54];
  }
  const handleRemoveCoupon = t21;
  let t22;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <Ticket01Icon />;
    $[55] = t22;
  } else {
    t22 = $[55];
  }
  let t23;
  if ($[56] !== t) {
    t23 = t("dashboard.funnel.configuration.offer.coupons");
    $[56] = t;
    $[57] = t23;
  } else {
    t23 = $[57];
  }
  let t24;
  if ($[58] !== t) {
    t24 = t("dashboard.funnel.configuration.offer.coupon_header-description");
    $[58] = t;
    $[59] = t24;
  } else {
    t24 = $[59];
  }
  let t25;
  if ($[60] !== t) {
    t25 = t("dashboard.funnel.configuration.offer.add_coupon");
    $[60] = t;
    $[61] = t25;
  } else {
    t25 = $[61];
  }
  let t26;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <PlusIcon />;
    $[62] = t26;
  } else {
    t26 = $[62];
  }
  let t27;
  if ($[63] !== handleOpenModal || $[64] !== t25) {
    t27 = <Button aria-label={t25} variant="secondary" size="icon-md" onClick={handleOpenModal}>{t26}</Button>;
    $[63] = handleOpenModal;
    $[64] = t25;
    $[65] = t27;
  } else {
    t27 = $[65];
  }
  let t28;
  if ($[66] !== columns || $[67] !== data || $[68] !== renderExpiration || $[69] !== renderLimitOfUse || $[70] !== renderRemoveButton || $[71] !== t) {
    t28 = data.length > 0 ? <Table caption={t("dashboard.funnel.configuration.offer.coupons")} columns={columns} data={{
      items: data,
      hasMore: false
    }} renderMobileRow={coupon_8 => <><MobileCardHeader icon={<IconTile size="s" tone="outline"><Ticket01Icon /></IconTile>} title={coupon_8.innerName} action={renderRemoveButton(coupon_8)} /><ComponentsTable.Mobile.Cell label={t("dashboard.coupon.coupon_code")}><span className="block truncate">{coupon_8.code}</span></ComponentsTable.Mobile.Cell><ComponentsTable.Mobile.Cell label={t("dashboard.coupon.expiration_date")}>{renderExpiration(coupon_8)}</ComponentsTable.Mobile.Cell><ComponentsTable.Mobile.Cell label={t("dashboard.coupon.limit_of_use")}>{renderLimitOfUse(coupon_8)}</ComponentsTable.Mobile.Cell><ComponentsTable.Mobile.Cell label={t("dashboard.coupon.coupons_used_available")}>{renderNumberOfUse(coupon_8)}</ComponentsTable.Mobile.Cell></>} /> : null;
    $[66] = columns;
    $[67] = data;
    $[68] = renderExpiration;
    $[69] = renderLimitOfUse;
    $[70] = renderRemoveButton;
    $[71] = t;
    $[72] = t28;
  } else {
    t28 = $[72];
  }
  let t29;
  if ($[73] !== t23 || $[74] !== t24 || $[75] !== t27 || $[76] !== t28) {
    t29 = <OfferConfigurationCard icon={t22} title={t23} description={t24} action={t27}>{t28}</OfferConfigurationCard>;
    $[73] = t23;
    $[74] = t24;
    $[75] = t27;
    $[76] = t28;
    $[77] = t29;
  } else {
    t29 = $[77];
  }
  const t30 = !!couponToDelete;
  let t31;
  if ($[78] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = () => setCouponToDelete(null);
    $[78] = t31;
  } else {
    t31 = $[78];
  }
  let t32;
  if ($[79] !== t) {
    t32 = t("dashboard.funnel.configuration.common.coupon.remove_confirmation");
    $[79] = t;
    $[80] = t32;
  } else {
    t32 = $[80];
  }
  let t33;
  if ($[81] !== handleRemoveCoupon || $[82] !== t30 || $[83] !== t32) {
    t33 = <Confirmation status="error" opened={t30} onClose={t31} onConfirm={handleRemoveCoupon} confirmationText={t32} />;
    $[81] = handleRemoveCoupon;
    $[82] = t30;
    $[83] = t32;
    $[84] = t33;
  } else {
    t33 = $[84];
  }
  let t34;
  if ($[85] !== availableCoupons || $[86] !== close || $[87] !== couponErrors || $[88] !== createFieldErrors || $[89] !== currency || $[90] !== handleAttachCoupon || $[91] !== handleCreateCoupon || $[92] !== opened) {
    t34 = <AttachCouponModal coupons={availableCoupons} couponFieldErrors={couponErrors} createFieldErrors={createFieldErrors} currency={currency} onAttachCoupon={handleAttachCoupon} onClose={close} onCreateCoupon={handleCreateCoupon} opened={opened} />;
    $[85] = availableCoupons;
    $[86] = close;
    $[87] = couponErrors;
    $[88] = createFieldErrors;
    $[89] = currency;
    $[90] = handleAttachCoupon;
    $[91] = handleCreateCoupon;
    $[92] = opened;
    $[93] = t34;
  } else {
    t34 = $[93];
  }
  let t35;
  if ($[94] !== t29 || $[95] !== t33 || $[96] !== t34) {
    t35 = <>{t29}{t33}{t34}</>;
    $[94] = t29;
    $[95] = t33;
    $[96] = t34;
    $[97] = t35;
  } else {
    t35 = $[97];
  }
  return t35;
}
function _temp5(coupon_7) {
  return coupon_7.id;
}
function _temp4(coupon_5) {
  return coupon_5.id;
}
function _temp3(coupon_4) {
  return coupon_4.code;
}
function _temp2(coupon_3) {
  return <TooltipTextOverflow className="text-text-primary">{coupon_3.innerName}</TooltipTextOverflow>;
}
function _temp(coupon_1) {
  return coupon_1.limitOfUse === null ? coupon_1.numberOfUse ?? 0 : `${coupon_1.numberOfUse ?? 0}/${coupon_1.limitOfUse}`;
}
export default CouponSelector;